const StepperReducer = (state = 0, action) => {

    if(action.type == "NextStep" && state < 6){
        return state + 1;
    }else if(action.type == "PrevStep" && state > 0) {
        return state - 1;
    }else if(action.type === "ChangeStep"){
        return action.payload;
    }else if(action.type === "RESET"){
        return 0;
    }else if(action.type === "RESET_CERTIFICATE_FLOW"){
        return 0;
    }
    else {
        return state;
    }
    

}

export default StepperReducer